import { accessRole } from '../../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Input, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"
import Shimmer from 'react-shimmer-effect'

import apiResponse from '../../../../../services/apiResponse'

import IndexBloc from '../Index/Blocs/IndexBloc'

import moment from "moment"

class IndexView extends Component {

    timer
    indexBloc = new IndexBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            positionOption: [],
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'position_id',
                    order: 'asc' 
                }
            },
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    loadDetail = async () => {
        await this.indexBloc.fetchDetail({ uuid: this.props.uuid })
    }

    componentDidMount() {
        this.loadDetail()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break
                default:
                    break
            }
        })       

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
    }

   customFormRow = (labelText, detailData, isLoading) => {
        return (
          <Row className="mb-3">
            <label htmlFor="name" className="col-md-3 col-form-label">
              {labelText}
            </label>
            <Col >
              {isLoading ? (
                <Shimmer>
                  <div
                    style={{
                      width: '100%',
                      height: '16px',
                      alignSelf: 'center',
                      borderRadius: '8px',
                      marginTop: 'calc(0.47rem + 1px)',
                      marginBottom: 'calc(0.47rem + 1px)',
                      fontSize: 'inherit',
                      lineHeight: '1.5',
                    }}
                  />
                </Shimmer>
              ) : (
                <Label className="col-form-label">{detailData || '-'}</Label>
              )}
            </Col>
          </Row>
        );
      };

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/komponen_penilaian_bobot_tunjangan_khusus.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail Bobot Tunjangan Khusus</CardTitle>
                            <hr />
                            {/* {this.customFormRow("Komponen Penilaian", detail?.assessment_component_detail?.assessment_component_parent_detail?.assessment_component_name, !detail) }
                            {this.customFormRow("Kriteria Penilaian", detail?.assessment_component_detail?.assessment_component_name, !detail)} */}
                            {this.customFormRow("Nama Bobot", detail?.special_allowance_name, !detail)}
                            {this.customFormRow("Nilai Bobot", detail?.special_allowance_value, !detail)}
                            {this.customFormRow("Berlaku Dari", detail?.special_allowance_start_date, !detail)}
                            {this.customFormRow("Berlaku Sampai", detail?.special_allowance_end_date, !detail)}
                        </CardBody>
                    </Card>

                </Container>
               
            </Fragment>
        )
    }

}

export default IndexView